import { apiPost, apiPut, apiDelete, apiGet, apiPostFile } from '../lib/api'

export const SAMPLE_TESTS_CREATE_START = 'SAMPLE_TESTS_CREATE_START'
export const SAMPLE_TESTS_CREATE_SUCCESS = 'SAMPLE_TESTS_CREATE_SUCCESS'
export const SAMPLE_TESTS_CREATE_ERROR = 'SAMPLE_TESTS_CREATE_ERROR'

export const TEST_SAVE_START = 'TEST_SAVE_START'
export const TEST_SAVE_SUCCESS = 'TEST_SAVE_SUCCESS'
export const TEST_SAVE_ERROR = 'TEST_SAVE_ERROR'

export const UPLOAD_MATERIALS = 'UPLOAD_MATERIALS'

export const TEST_ADD_START = 'TEST_ADD_START'
export const TEST_ADD_SUCCESS = 'TEST_ADD_SUCCESS'
export const TEST_ADD_ERROR = 'TEST_ADD_ERROR'

export const TEST_CLEAR_DETAIL = 'TEST_CLEAR_DETAIL'
export const TESTS_CLEAR = 'TEST_CLEAR'

export const TEST_EDIT_START = 'TEST_EDIT_START'
export const TEST_EDIT_SUCCESS = 'TEST_EDIT_SUCCESS'
export const TEST_EDIT_ERROR = 'TEST_EDIT_ERROR'

export const TEST_DELETE_START = 'TEST_DELETE_START'
export const TEST_DELETE_SUCCESS = 'TEST_DELETE_SUCCESS'
export const TEST_DELETE_ERROR = 'TEST_DELETE_ERROR'

export const TEST_LOAD_START = 'TEST_LOAD_START'
export const TEST_LOAD_SUCCESS = 'TEST_LOAD_SUCCESS'
export const TEST_LOAD_ERROR = 'TEST_LOAD_ERROR'

export const TESTS_LOAD_START = 'TESTS_LOAD_START'
export const TESTS_LOAD_SUCCESS = 'TESTS_LOAD_SUCCESS'
export const TESTS_LOAD_ERROR = 'TESTS_LOAD_ERROR'

export const GET_PUBLIC_TESTS_START = 'GET_PUBLIC_TESTS_START'
export const GET_PUBLIC_TESTS_SUCCESS = 'GET_PUBLIC_TESTS_SUCCESS'
export const GET_PUBLIC_TESTS_ERROR = 'GET_PUBLIC_TESTS_ERROR'

export const INIT_TEST = 'INIT_TEST'
export const SET_RESULT = 'SET_RESULT'

export const INIT_ANSWERS = 'INIT_ANSWERS'
export const UPDATE_ANSWERS = 'UPDATE_ANSWERS'
export const INIT_TRANSLATION_ANSWERS = 'INIT_TRANSLATION_ANSWERS'
export const UPDATE_TRANSLATION_ANSWERS = 'UPDATE_TRANSLATION_ANSWERS'

export const CLEAR_ANSWERS = 'CLEAR_ANSWERS'

export const loadTests = () => ({ getState, fetch }) => ({
  type: 'TESTS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'test',
    getState,
  }),
})

// export const saveTest = (body) => ({ getState, fetch }) => ({
//   type: 'TEST_SAVE',
//   payload: apiPost({
//     fetch,
//     endpoint: 'test/saveResult',
//     getState,
//     body,
//   }),
// })

export const createTest = (body) => ({ getState, fetch }) => ({
  type: 'TEST_ADD',
  payload: apiPost({
    fetch,
    endpoint: 'test',
    getState,
    body,
  }),
})

export const uploadMaterials = (body) => ({ getState, fetch }) => ({
  type: 'UPLOAD_MATERIALS',
  payload: apiPostFile({
    fetch,
    endpoint: 'test/upload-materials',
    getState,
    body,
  }),
})

export const editTest = (body) => ({ getState, fetch }) => ({
  type: 'TEST_EDIT',
  payload: apiPut({
    fetch,
    endpoint: `test/${body.id}`,
    getState,
    body,
  }),
})
export const loadTestDetail = (id) => ({ getState, fetch }) => ({
  type: 'TEST_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `test/${id}`,
    getState,
  }),
})

export const deleteTest = (id) => ({ getState, fetch }) => ({
  type: 'TEST_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `test/${id}`,
    getState,
  }),
})

export const getPublicTests = (query) => ({ getState, fetch }) => ({
  type: 'GET_PUBLIC_TESTS',
  payload: apiGet({
    fetch,
    endpoint: `/test/search/public/${query}`,
    getState,
  }),
})

export const savePublicTest = (id) => ({ getState, fetch }) => ({
  type: 'TEST_SAVE',
  payload: apiPost({
    fetch,
    endpoint: `/test/favorite/${id}`,
    getState,
  }),
})

export const removePublicTest = (id) => ({ getState, fetch }) => ({
  type: 'TEST_REMOVE_FAVORITE',
  payload: apiDelete({
    fetch,
    endpoint: `/test/favorite/${id}`,
    getState,
  }),
})

export const clearTestDetail = () => ({
  type: TEST_CLEAR_DETAIL,
})

export const clearTests = () => ({
  type: TESTS_CLEAR,
})

export const initTest = () => ({
  type: INIT_TEST,
  payload: {
    points: 0,
    finished: false,
  },
})

export const initAnswers = (id, answers) => ({
  type: INIT_ANSWERS,
  payload: { id, answers },
})

export const updateAnswers = (id, wordId, value) => ({
  type: UPDATE_ANSWERS,
  payload: { id, wordId, value },
})

export const setResult = (data) => ({
  type: SET_RESULT,
  payload: data,
})

export const clearAnswers = () => ({
  type: CLEAR_ANSWERS,
})

export const createSampleTests = () => ({ getState, fetch }) => ({
  type: 'SAMPLE_TESTS_CREATE',
  payload: apiPost({
    fetch,
    endpoint: '/about/create-sample-tests',
    getState,
  }),
})



// WEBPACK FOOTER //
// ./src/common/tests/actions.js